import DVCore from "./core/DVCore";

const AboutAPI = {};

AboutAPI.baseURL = "/about";

AboutAPI.get = (onSuccess, onFail, onError = null) =>
    DVCore.get(AboutAPI.baseURL, null, onSuccess, onFail, onError);

export default AboutAPI;
